// #### Recipes ####
export const GroupProfileRecipe = {
    $type$: 'Recipe',
    name: 'GroupProfile',
    rule: [
        {
            itemprop: 'group',
            itemtype: { type: 'referenceToId', allowedTypes: new Set(['Group']) },
            isId: true
        },
        {
            itemprop: 'name',
            itemtype: { type: 'string' }
        },
        {
            itemprop: 'picture',
            itemtype: { type: 'referenceToBlob' }
        }
    ]
};
export default [GroupProfileRecipe];
//# sourceMappingURL=GroupProfile.js.map